import styled from 'styled-components';

export const InformationComponent = styled.div`
	display: flex;
	flex-direction: row;
	gap: 32px;
	width: 100%;

	@media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
		flex-direction: column;
		gap: 0;
	}
`;

export const InformationCard = styled.div`
	width: 100%;
`;

export const Card = styled.div`
	background-color: ${({ theme }) => theme.colors.principal.pure};
	border: 1px solid ${({ theme }) => theme.colors.principal.ceres};
	border-radius: 12px;
	padding: 16px 22px;
	width: 100%;
`;

export const CardTitle = styled.p`
	color: #140f33;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	letter-spacing: -0.18px;
	line-height: 28px;
`;

export const CardAmount = styled.p`
	color: #0f0f0f;
	font-size: 36px;
	font-style: normal;
	font-weight: 600;
	letter-spacing: -1.08px;
	line-height: normal;
	margin-bottom: 40px;
	margin-top: 8px;
`;

export const CardTodayButton = styled.button`
	align-items: flex-start;
	background: #f8f8f8;
	border: none;
	border-radius: 12px;
	color: #0f0f0f;
	display: flex;
	font-size: 12px;
	gap: 10px;
	padding: 8px 12px;
`;

export const CardOrderTitle = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
`;

export const CardInfo = styled.div`
	margin-left: -12px;
`;

interface BarProps {
	color?: string;
}

interface InfoProps {
	width?: string; // Permite definir el width en porcentaje u otras unidades
}

export const Info = styled.div<InfoProps>`
	border-left: 1px dashed #afafaf;
	display: flex;
	flex-direction: column;
	gap: 35px;
	min-width: 100px;
	width: ${({ width }) => width || '10%'};
`;

export const InfoLabels = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding-left: 8px;
	width: 100%;
`;

export const Amt = styled.p`
	color: #0f0f0f;
	font-size: 24px;
	font-style: normal;
	font-weight: 600;
	letter-spacing: -0.24px;
`;

export const Txt = styled.p`
	color: #636172;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	height: 34px;
`;

export const TxtTool = styled.p`
	color: #636172;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	height: auto;
`;

export const Pct = styled.span<BarProps>`
	color: ${(props) => (props.color ? '#3b82f6' : '#111')};
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 100% */
`;

export const BarWrap = styled.div`
	background: #e0e0e0;
	border-radius: 4px;
	height: 24px;
	overflow: hidden;
	position: relative;
	width: 100%;
`;

export const Bar = styled.div<BarProps>`
	background: ${(props) => (props.color ? '#3b82f6' : '#111')};
	border-radius: 4px;
	height: 24px;
	margin-left: -8px;
	width: calc(100% + 7px);
`;

export const CardFooter = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
`;

export const LabelFooter = styled.p`
	color: #646174;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px;
	margin-top: 10px;
`;

export const CustomTool = styled.div`
	background: #eaeaea;
	border: none;
	border-radius: 8px;
	padding: 10px;
`;
